/* ==========================================================================
   TNF · Pflichtfelder am Produkt
   --------------------------------------------------------------------------
   Eine gemeinsame Pruefung fuer alle eigenen Produktfelder:

     data-tnf-kind="fin"     Fahrzeug-Identifikationsnummer (17 Zeichen)
     data-tnf-kind="select"  Auswahlfeld, z. B. Fahrzeugauswahl
     data-tnf-kind="text"    Freitextfeld

   Aufgaben:
   - FIN normalisieren (Grossbuchstaben, kein I/O/Q, keine Leerzeichen) + Zaehler
   - Absenden blockieren, solange ein Pflichtfeld fehlt
   - Express-Checkout sperren, bis ALLE Pflichtfelder ausgefuellt sind
   - Add-to-Cart von Apps abfangen, die am Formular vorbei arbeiten
   - Werte in die Sticky-Leiste spiegeln

   Kein jQuery. Laeuft auch nach AJAX-Nachladen (Quick View, Quick Shop,
   Variantenwechsel) dank MutationObserver.
   ========================================================================== */
(function () {
  'use strict';

  var FIN_VALID = /^[A-HJ-NPR-Z0-9]{17}$/;
  var FIN_CLEAN = /[^A-HJ-NPR-Z0-9]/g;

  /* ---------------------------------------------------------- Hilfsfunktionen */

  function all(sel, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(sel));
  }
  /** Deaktivierte Felder (ausgeblendete Bedingungsfelder) zaehlen nicht mit. */
  function fields(scope) {
    return all('[data-tnf-field]', scope).filter(function (el) { return !el.disabled; });
  }
  function finFields(scope) { return all('[data-tnf-kind="fin"]', scope); }

  function normalizeFin(v) {
    return String(v || '').toUpperCase().replace(/\s|-/g, '').replace(FIN_CLEAN, '').slice(0, 17);
  }

  /** Ist dieses eine Feld in Ordnung? */
  function fieldValid(el) {
    if (el.getAttribute('data-tnf-kind') === 'fin') {
      return FIN_VALID.test(normalizeFin(el.value));
    }
    if (!el.required) return true;
    return String(el.value || '').trim() !== '';
  }

  /** Sind ALLE Pflichtfelder auf der Seite in Ordnung? */
  function allValid(scope) {
    return fields(scope).every(fieldValid);
  }

  function showError(el, show) {
    var wrap = el.closest('[data-tnf-fieldwrap]');
    if (!wrap) return;
    var err = wrap.querySelector('[data-tnf-field-error]');
    if (err) err.hidden = !show;
    el.setAttribute('aria-invalid', show ? 'true' : 'false');
  }

  function updateFinCounter(input) {
    var wrap = input.closest('[data-tnf-fieldwrap]');
    if (!wrap) return;
    var c = wrap.querySelector('.tnf-fin__count');
    if (!c) {
      c = document.createElement('span');
      c.className = 'tnf-fin__count';
      var err = wrap.querySelector('[data-tnf-field-error]');
      if (err) wrap.insertBefore(c, err); else wrap.appendChild(c);
    }
    c.textContent = input.value.length + ' / 17';
    c.setAttribute('data-state', FIN_VALID.test(normalizeFin(input.value)) ? 'ok' : 'pending');
  }

  /* ------------------------------------------------- Spiegel + Express-Sperre */

  /**
   * Bedingte Felder ein-/ausblenden: data-tnf-showif enthaelt die Werte der
   * Fahrzeugauswahl, bei denen das Feld erscheinen soll (mit || getrennt).
   * Ausgeblendete Felder werden zusaetzlich deaktiviert - dann blockieren sie
   * weder das Absenden noch den Express-Checkout und gehen auch nicht mit
   * an die Bestellung.
   */
  function applyConditions() {
    var driver = document.querySelector('[name="properties[Fahrzeugauswahl]"]');
    var current = driver ? String(driver.value || '').trim() : '';

    all('[data-tnf-showif]').forEach(function (wrap) {
      var allowed = wrap.getAttribute('data-tnf-showif').split('||').map(function (v) {
        return v.trim();
      });
      var show = allowed.indexOf(current) !== -1;

      wrap.hidden = !show;
      all('[data-tnf-field]', wrap).forEach(function (el) {
        el.disabled = !show;

        // Zusaetzlich den name entfernen: manche Theme-Skripte serialisieren das
        // Formular selbst und nehmen dabei auch deaktivierte Felder mit - dann
        // haengt eine leere Eigenschaft an der Bestellposition.
        if (!el.dataset.tnfName && el.name) el.dataset.tnfName = el.name;
        if (show) {
          if (el.dataset.tnfName) el.name = el.dataset.tnfName;
        } else {
          el.name = '';
          el.value = '';
          var err = wrap.querySelector('[data-tnf-field-error]');
          if (err) err.hidden = true;
          el.setAttribute('aria-invalid', 'false');
        }
      });
    });
  }

  /**
   * "Ich habe die FIN noch nicht" - die bewusste Ausnahme.
   *
   * Haken gesetzt: FIN-Feld wird deaktiviert und geleert, dafuer traegt ein
   * verstecktes Feld den Ersatztext als Eigenschaft FIN. Damit steht in der
   * Bestellung ein lesbarer Grund statt einer Fantasie-FIN aus Nullen - und
   * das Gate laesst durch, weil deaktivierte Felder nicht mitzaehlen.
   */
  function applyOptouts() {
    all('[data-tnf-optout]').forEach(function (cb) {
      var wrap = cb.closest('[data-tnf-fieldwrap]');
      if (!wrap) return;

      var target = document.getElementById(cb.getAttribute('data-tnf-optout-for'))
                || wrap.querySelector('[data-tnf-kind="fin"]');
      var ersatz = wrap.querySelector('[data-tnf-optout-value]');
      var an = cb.checked;

      wrap.classList.toggle('is-later', an);

      if (target) {
        if (!target.dataset.tnfName && target.name) target.dataset.tnfName = target.name;
        target.disabled = an;
        if (an) {
          target.name = '';
          target.value = '';
          showError(target, false);
        } else if (target.dataset.tnfName) {
          target.name = target.dataset.tnfName;
        }
      }

      if (ersatz) {
        ersatz.disabled = !an;
        ersatz.name = an ? (ersatz.dataset.tnfName || '') : '';
      }
    });
  }

  /** Was am Ende als FIN mitgeht - echte Nummer oder Ersatztext. */
  function effectiveFin() {
    var aktiv = all('[data-tnf-optout]').filter(function (cb) { return cb.checked; });
    if (aktiv.length) {
      var wrap = aktiv[0].closest('[data-tnf-fieldwrap]');
      var ersatz = wrap && wrap.querySelector('[data-tnf-optout-value]');
      return ersatz ? ersatz.value : '';
    }
    return currentFin() || '';
  }

  function syncAll() {
    applyConditions();
    applyOptouts();
    var fin = effectiveFin();
    all('[data-tnf-fin-mirror]').forEach(function (m) {
      m.value = fin;
      // Ohne Wert lieber gar nicht mitschicken - sonst steht eine leere
      // Eigenschaft "FIN" auf der Bestellposition.
      m.disabled = !fin;
    });

    // Pro Formular pruefen, nicht pro Seite: sonst sperrt ein offenes Quick View
    // mit eigenem Pflichtfeld auch den Express-Bereich des Hauptprodukts.
    // Formulare ohne eigene Felder (Sticky-Leiste) fallen auf die Seite zurueck.
    all('[data-tnf-express]').forEach(function (box) {
      var form = box.closest('form');
      var scope = (form && fields(form).length) ? form : document;
      var ok = allValid(scope);
      box.classList.toggle('is-locked', !ok);
      var hint = box.querySelector('[data-tnf-express-hint]');
      if (hint) hint.hidden = ok;
    });
  }

  /* ----------------------------------------------------------------- Bindung */

  function initField(el) {
    if (el.dataset.tnfBound === '1') return;
    el.dataset.tnfBound = '1';

    var isFin = el.getAttribute('data-tnf-kind') === 'fin';

    el.addEventListener(el.tagName === 'SELECT' ? 'change' : 'input', function () {
      if (isFin) {
        var pos = el.selectionStart;
        var before = el.value;
        var after = normalizeFin(before);
        if (before !== after) {
          el.value = after;
          try { el.setSelectionRange(pos, pos); } catch (e) {}
        }
        updateFinCounter(el);
      }
      if (el.getAttribute('aria-invalid') === 'true' && fieldValid(el)) showError(el, false);
      syncAll();
    });

    el.addEventListener('blur', function () {
      if (String(el.value || '').trim() !== '' && !fieldValid(el)) showError(el, true);
    });

    if (isFin) updateFinCounter(el);
  }

  /* ---------------------------------------------------------------- Formular */

  function validateForm(form) {
    var own = fields(form);

    if (!own.length) {
      // Formular ohne eigene Felder (Sticky-Leiste) - gegen die Seite pruefen
      if (!form.querySelector('[data-tnf-fin-mirror]')) return true;
      return complainPage();
    }

    var ok = true;
    own.forEach(function (el) {
      if (fieldValid(el)) {
        if (el.getAttribute('data-tnf-kind') === 'fin') el.value = normalizeFin(el.value);
        showError(el, false);
      } else {
        showError(el, true);
        if (ok) focusField(el);
        ok = false;
      }
    });
    syncAll();
    return ok;
  }

  function complainPage() {
    var bad = fields(document).filter(function (el) { return !fieldValid(el); });
    if (!bad.length) { syncAll(); return true; }
    bad.forEach(function (el) { showError(el, true); });
    focusField(bad[0]);
    return false;
  }

  function focusField(el) {
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function initForm(form) {
    if (form.dataset.tnfBound === '1') return;
    // absichtlich OHNE fields(): auch Formulare binden, deren einziges Feld
    // gerade per Bedingung deaktiviert ist
    if (!form.querySelector('[data-tnf-field]') && !form.querySelector('[data-tnf-fin-mirror]')) return;
    form.dataset.tnfBound = '1';

    form.addEventListener('submit', function (e) {
      if (!validateForm(form)) { e.preventDefault(); e.stopImmediatePropagation(); }
    }, true);

    form.addEventListener('click', function (e) {
      var btn = e.target.closest('button, input[type="submit"], [name="add"], [data-btn-addToCart]');
      if (!btn) return;
      if (btn.type === 'button' && !btn.matches('[name="add"], [data-btn-addToCart]')) return;
      if (!validateForm(form)) { e.preventDefault(); e.stopImmediatePropagation(); }
    }, true);
  }

  /* -------------------------------------------------- Netz-Schutz (AJAX-Apps) */

  function pageHasFields() { return fields(document).length > 0; }

  function currentFin() {
    var f = finFields(document);
    return f.length ? normalizeFin(f[0].value) : null;
  }

  /** Alle Pflichtwerte der Seite als { "properties[X]": "Wert" } */
  function currentValues() {
    var out = {};
    fields(document).forEach(function (el) {
      if (!el.name) return;
      var v = el.getAttribute('data-tnf-kind') === 'fin' ? normalizeFin(el.value) : String(el.value || '').trim();
      if (v) out[el.name] = v;
    });
    return out;
  }

  function isCartAdd(url) {
    try { return String(url).indexOf('/cart/add') !== -1; } catch (e) { return false; }
  }

  function inject(body, values) {
    var keys = Object.keys(values);
    if (!keys.length) return body;
    try {
      if (body instanceof FormData) {
        keys.forEach(function (k) { if (!body.has(k)) body.append(k, values[k]); });
        return body;
      }
      if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
        keys.forEach(function (k) { if (!body.has(k)) body.append(k, values[k]); });
        return body;
      }
      if (typeof body === 'string') {
        var t = body.trim();
        if (t.charAt(0) === '{') {
          var o = JSON.parse(body);
          var props = {};
          keys.forEach(function (k) {
            var m = k.match(/^properties\[(.+)\]$/);
            if (m) props[m[1]] = values[k];
          });
          var apply = function (item) {
            item.properties = item.properties || {};
            Object.keys(props).forEach(function (p) {
              if (!item.properties[p]) item.properties[p] = props[p];
            });
          };
          if (Array.isArray(o.items)) o.items.forEach(apply); else apply(o);
          return JSON.stringify(o);
        }
        keys.forEach(function (k) {
          if (body.indexOf(encodeURIComponent(k)) === -1 && body.indexOf(k) === -1) {
            body += (body.length ? '&' : '') + encodeURIComponent(k) + '=' + encodeURIComponent(values[k]);
          }
        });
        return body;
      }
    } catch (e) {}
    return body;
  }

  var nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function') {
    window.fetch = function (input, init) {
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      if (isCartAdd(url) && pageHasFields()) {
        if (!allValid(document)) {
          complainPage();
          return Promise.reject(new Error('TNF: Pflichtfeld fehlt.'));
        }
        if (init && init.body != null) init.body = inject(init.body, currentValues());
      }
      return nativeFetch.apply(this, arguments);
    };
  }

  var nativeOpen = XMLHttpRequest.prototype.open;
  var nativeSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__tnfCartAdd = isCartAdd(url);
    return nativeOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    if (this.__tnfCartAdd && pageHasFields()) {
      if (!allValid(document)) { complainPage(); return; }
      if (body != null) {
        try { return nativeSend.call(this, inject(body, currentValues())); } catch (e) {}
      }
    }
    return nativeSend.apply(this, arguments);
  };

  /* --------------------------------------------------------------- Bootstrap */

  /**
   * EasyFlow entfernen, wo wir eigene Felder ausgeben.
   * Nur Ausblenden genuegt nicht - EasyFlows Script prueft beim Add-to-Cart
   * seine eigenen Felder und blockiert den Warenkorb, solange sie existieren.
   */
  function removeEasyFlow() {
    if (!document.querySelector('[data-tnf-options-active]')) return;
    all('.ef__product-option-root').forEach(function (el) { el.remove(); });
  }

  function initOptout(cb) {
    if (cb.dataset.tnfBound === '1') return;
    cb.dataset.tnfBound = '1';
    cb.addEventListener('change', function () {
      syncAll();
      // Nach dem Abwaehlen direkt ins Feld springen - der Kunde will jetzt
      // tippen, nicht erst suchen.
      if (!cb.checked) {
        var t = document.getElementById(cb.getAttribute('data-tnf-optout-for'));
        if (t) { try { t.focus({ preventScroll: true }); } catch (e) {} }
      }
    });
  }

  function scan() {
    removeEasyFlow();
    // ALLE Felder binden, auch gerade deaktivierte - sonst bekommt ein Feld,
    // das erst durch eine Bedingung eingeblendet wird, nie einen Handler.
    all('[data-tnf-field]').forEach(initField);
    all('[data-tnf-optout]').forEach(initOptout);
    all('form[action*="/cart/add"]').forEach(initForm);
    syncAll();
  }

  function boot() {
    scan();
    new MutationObserver(function (m) {
      for (var i = 0; i < m.length; i++) {
        if (m[i].addedNodes.length) { scan(); return; }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
